<template>
  <div
    class="filters__wrapper mb-3"
  >
    <div>
      <b-form-select
        id="jobQueueFilterField"
        v-model="jobQueueState.jobQueue.filterField"
        :options="options"
        @change="updateDataHandler"
      >
        <template #first>
          <b-form-select-option
            :value="null"
            disabled
          >
            -- Select filter field --
          </b-form-select-option>
        </template>
      </b-form-select>
    </div>
    <div>
      <b-input-group>
        <!-- Status dropdown -->
        <b-form-select
          v-if="isStatusField"
          v-model="jobQueueState.jobQueue.searchValue"
          :options="statusOptions"
          class="filter-select"
          @change="updateDataHandler"
        />
        <!-- IsBlocked dropdown -->
        <b-form-select
          v-else-if="isIsBlockedField"
          v-model="jobQueueState.jobQueue.searchValue"
          :options="isBlockedOptions"
          class="filter-select"
          @change="updateDataHandler"
        />
        <!-- Date filter -->
        <template v-else-if="isDateField">
          <div class="d-flex align-items-center w-100">
            <custom-date-picker
              v-model="dateFrom"
              placeholder="From date (optional)"
              input-class="input-editor form-control"
              class="date-filter"
              type="datetime"
              format="YYYY-MM-DD HH:mm:ss"
              style="flex:1;"
              @input="onDateChange"
            />
            <span class="mx-2">to</span>
            <custom-date-picker
              v-model="dateTo"
              placeholder="To date (optional)"
              input-class="input-editor form-control"
              class="date-filter"
              type="datetime"
              format="YYYY-MM-DD HH:mm:ss"
              style="flex:1;"
              @input="onDateChange"
            />
            <b-button
              class="ml-1"
              @click="handleClearFilter"
            >
              Reset
            </b-button>
          </div>
        </template>
        <!-- Default text input -->
        <b-form-input
          v-else
          v-model="jobQueueState.jobQueue.searchValue"
          type="search"
          placeholder="Filter text"
          @input="updateDataHandler"
        />
        <b-input-group-append>
          <b-button
            v-if="!isDateField"
            @click="handleClearFilter"
          >
            Reset
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {
  mapState: jobQueueMapState,
  mapActions: jobQueueMapActions,
} = createNamespacedHelpers('monitoring');

export default {
  name: 'FilterComponent',
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dateFrom: null,
      dateTo: null,
    };
  },
  computed: {
    ...jobQueueMapState({
      jobQueueState: state => state,
    }),
    isStatusField() {
      return this.jobQueueState.jobQueue.filterField === 'status';
    },
    isIsBlockedField() {
      return this.jobQueueState.jobQueue.filterField === 'isBlocked';
    },
    isDateField() {
      return (
        this.jobQueueState.jobQueue.filterField === 'createdDateTime' ||
        this.jobQueueState.jobQueue.filterField === 'startedDateTime'
      );
    },
    statusOptions() {
      return [
        { value: '', text: '-- Select status --', disabled: true },
        { value: 'Successful', text: 'Successful' },
        { value: 'Failed', text: 'Failed' },
        { value: 'Not Started', text: 'Not Started' },
        { value: 'Running', text: 'Running' },
        { value: 'Cancelled', text: 'Cancelled' },
      ];
    },
    isBlockedOptions() {
      return [
        { value: '', text: '-- Select value --', disabled: true },
        { value: 'True', text: 'True' },
        { value: 'False', text: 'False' },
      ];
    },
  },
  methods: {
    ...jobQueueMapActions(['updateTableByFilter', 'clearFilter']),
    updateDataHandler() {
      this.updateTableByFilter();
    },
    handleClearFilter() {
      this.clearFilter();
      this.dateFrom = null;
      this.dateTo = null;
    },
    onDateChange() {
      // Compose the date filter value as an object
      const dateFilter = {
        from: this.dateFrom || null,
        to: this.dateTo || null,
      };
      this.jobQueueState.jobQueue.searchValue = dateFilter;
      this.updateTableByFilter();
    },
  },
};
</script>

<style lang="scss">
.filters__wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 10px;
}
</style>